class PopupClear {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('.popup-clear').forEach(function (el) {
            el.addEventListener('click', function() {
                el.remove()
            })

            el.querySelectorAll('.popup-clear-action').forEach(function (elAction) {
                elAction.addEventListener('click', function() {
                    el.remove()
                })
            })
        })
    }
}

export default PopupClear